import React, { Component } from 'react';
import dateFns from 'date-fns';
import FuelerIcon from './components/FuelerIcon';
import styled from 'styled-components';

class AppHeaderInfo extends Component {
    render() {
        const statusIcon = this.props.online ? 'online' : 'offline';
        const statusColor = this.props.online ? '#42B72A' : 'red';
        const statusSize = this.props.online ? '12px' : '16px';

        const InfoHorizontalLayout = styled.div`
            display: flex;
            flex-direction: row;
            justify-content: center;
            color: ${props => props.theme.primaryTextColor};
        `;

        const InfoVerticalLayout = styled.div`
            display: flex;
            flex-direction: column;
            justify-content: center;
        `;

        const NameAndStatus = styled.div`
            display: inline-flex;
            visibility: ${props => (props.haveUser ? 'visible' : 'hidden')};
        `;

        const NameContainer = styled.div`
            margin-right: 5px;
        `;

        const DateContainer = styled.div`
            font-size: 12px;
            text-align: center;
        `;

        return (
            <InfoHorizontalLayout>
                <InfoVerticalLayout>
                    <NameAndStatus haveUser={this.props.user && this.props.user.fullName}>
                        <NameContainer>{this.props.user.fullName}</NameContainer>
                        <FuelerIcon
                            icon={statusIcon}
                            size={statusSize}
                            fill={statusColor}
                            text={this.props.syncNumber > 0 ? this.props.syncNumber : ''}
                        />
                    </NameAndStatus>
                    <DateContainer>{dateFns.format(new Date(), 'MMM Do, YYYY')}</DateContainer>
                </InfoVerticalLayout>
            </InfoHorizontalLayout>
        );
    }
}

export default AppHeaderInfo;



// WEBPACK FOOTER //
// ./src/AppHeaderInfo.js